module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_hibiscus-389b69d726315f3f942461351a533f6b.png";